/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  RemoveTradingChallengeUsersOptions,
  RemoveTradingChallengeUsersResponses,
} from '../types/RemoveTradingChallengeUsers'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Remove users from a trading challenge. For COMPETITION_MANAGER, the challenge must be assigned in managed_competition_ids.
 * @summary Remove users from a trading challenge
 * {@link /v1/trading_challenges/remove_users}
 */
export function removeTradingChallengeUsers<ThrowOnError extends boolean = true>(
  options: Options<RemoveTradingChallengeUsersOptions, ThrowOnError>,
): Unwrappable<RequestResult<RemoveTradingChallengeUsersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/trading_challenges/remove_users',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<RemoveTradingChallengeUsersResponses, ThrowOnError>>,
  )
}
